import { createRoot } from 'react-dom/client'
import './styles.css'
import * as THREE from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Center, Bounds, OrbitControls, Instances, Instance } from '@react-three/drei'
import Colors from './Colors'
require('./path')

let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]
const ci = randI(Colors.length)
const ci2 = randI(Colors.length)
const cols = Colors[ci]
const cols2 = Colors[ci2]
const bgColor = cols.shift()
cols2.shift()
cols.push(rand(cols2))
cols.push(rand(cols2))
cols.push(rand(cols2))
cols.push(rand(cols2))
function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(fxrand() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}
shuffle(cols)
let started = false
let targetFb = 0
let off = null
export default function App() {
  const click = () => {
    device.context.resume();
    off = ((new Date().getTime()) - time.getTime()) % beatDur
    if (!started) {
      started = true
      genNotes()
      if (!isPlaying) {
        play()
      }
      timeouts.forEach((t, i) => clearTimeout(t))
      rowsAnimated = dimension + zz - 1
      // count = -1
      mode = randI(modes.length)
      // device.parameters[4].value = 0.8
      targetFb = 0.9
    } else {
      let randMode = randI(modes.length)
      noteModes = new Array(melodyLen).fill().map(() => randMode)
      dir = !dir
      started = false
      play()

      new Array((dimension + (zz))).fill().map((_, i) => {
        let d = ((0.002 * i)) * (2 + (i * (60 / zz)))
        timeouts[i] = setTimeout(() => {

          playNote(Math.max(beatDur, 0.01 + (d * 100)), notes[i % melodyLen])
          rowsAnimated -= 1;
        }, d * 1000)
      })
      // device.parameters[4].value = 0.5
      targetFb = 0

    }

  }
  let timeouts = []
  let z = dimension
  return (
    <div id="main" onMouseUp={() => click()}>
      <Canvas flat={true} dpr={[1, 2]}
        orthographic camera={{ position: [rand([z, -z]), rand([z, -z]), z], zoom: z, near: 0.00000000000000000001 }}>
        <Stuff />
        <color attach="background" args={[bgColor]} />
        <OrbitControls maxDistance={1}
          enablePan={false} enableZoom={true} dampingFactor={0.05}
        />
      </Canvas>
      <div id="overlay" />
    </div>
  )
}
function Stuff() {
  return (
    <Bounds fit margin={1.1 + ((dimension * 0.075))} damping={0}>
      <Center>
        <group rotation={[Math.PI * rand([0, 0, 0, 0, 0, 0, 0.5, 1, 1.5]), Math.PI * 0, 0]}>
          <Screens />
        </group>
      </Center>
    </Bounds>
  )
}

let dimension = rand([2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4])
let paths = window.hampath.generate({ width: dimension, height: dimension })
let melodyLen = paths.data.length - 1

let widthsBag = [20, 30, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100]
// let widthsBag = [100]
let defaultWidth = 100
let widths = new Array(paths.data.length).fill().map(() => (randI(100) > 80 ? rand(widthsBag) : defaultWidth) * 1.5)
let sc = (0.000002) / 1.5
let geo = new THREE.BoxGeometry(sc, sc, sc * 0.7)
let zz = Math.ceil(rand([2, 3, 4]) + (randI(40) / (dimension * 0.6))) + Math.floor((0 + randI(80)) / widths[0])
function Screens() {
  const sc = useRef();
  return (
    <Instances limit={100000} geometry={geo} ref={sc}>
      <meshBasicMaterial depthTest={false} color={randI(100 > 30) ? 'white' : rand(cols)} />
      {new Array(dimension).fill().map((_, x) =>
        <group key={x}>
          {new Array(dimension).fill().map((__, y) =>
            <group key={y} rotation={[0, Math.PI * (randI(100) > 97 ? rand([0.5, 1.5, 0]) : 0), Math.PI * rand([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5, 1.5])]}>
              {new Array(Math.ceil(((dimension + zz)))).fill().map((__, z) =>
                <group key={z} >
                  {((x * dimension) + y) !== (paths.data.length - 1) &&
                    <Line i={(x * dimension) + y} z={z} />
                  }
                </group>
              )}
            </group>
          )}
        </group>
      )}
    </Instances>
  )
}

let s = 0.0002
let zScale = rand([0.01 + (0.006 * dimension)]) * rand([1,1,1, 1.25, 1.5])
let getX = (x) => (((dimension - 1) * -0.5) * s) + (x * s)
let getY = (y) => (((dimension - 1) * -0.5) * s) + (y * s)
let getZ = (z) => ((z * s * zScale) + (0.5 * s * zScale))

let colMods = rand([4, 8, 10, 11]) * dimension
let colInf = rand([0.5, 0.25, 0.125])
let colAdd = 1 + randI(4)
let dir = true
function Line({ i, z }) {
  const ref = useRef();
  const ref2 = useRef();
  let p0 = paths.data[i]
  let p1 = paths.data[(i + 1) % paths.data.length]
  let x = (p0[0] - p1[0]) || 0
  let y = (p0[1] - p1[1])
  let sx = 1 + Math.abs((x * widths[i]))
  let sy = (sx !== 1) ? 1 : (1 + Math.abs(y * (widths[i])))
  useFrame((state) => {
    if ((dir ? (dimension + (zz - 1) - z) : z) > rowsAnimated) {
      ref.current.scale.x = 1
      ref.current.scale.y = 1
      ref2.current.scale.y = sy
    } else if ((((count) % melodyLen) === i) || (((count + 1) % melodyLen) === i)) {
      let m1 = Math.abs((modes[noteModes[i % melodyLen]](state.clock.getElapsedTime() * 5, z, p0[0])))
      let m2 = Math.abs((modes[noteModes[i % melodyLen]](state.clock.getElapsedTime() * 5, z, p0[1])))
      ref.current.scale.y = m1 || m2
    }
  })
  let ci = (Math.floor((i + z) / 3) % cols.length) ?
    ((Math.floor(((i * colInf) + (z)) / (colMods * (i)))) % cols.length) :
    ((Math.floor(((i * colInf) + (z)) / (colMods * (i))) + colAdd) % cols.length)
  return (
    <group ref={ref}>
      <group scale={[1, 1, 1]}>
        <Instance
          ref={ref2}
          color={cols[ci]}
          position={[getX(p0[0] - (x * 0.5)), getY(p0[1] - (y * 0.5)), getZ(z)]}
          scale={[sx, sy, 1]} />
      </group>
    </group>
  )
}
const container = document.getElementById('root')
container.style.background = bgColor
createRoot(container).render(<App />)
const instNotes = new Array(40).fill().map(() => rand(['C', 'D', 'E', 'F', 'G', 'A']) + rand([5, 6, 7]))

let last = ''
let notes = []
let genNotes = () => {
  notes = new Array(melodyLen).fill().map((_, i) => {
    let note = rand(instNotes)
    if (note === last) {
      note = rand(instNotes)
    }
    last = note
    return note
  })
}
let modes = [
  (t, c, r) => Math.cos(2 * r / c ^ 2 + (t)),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.1),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.1),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.15),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.15),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.05),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.05),
  (t, c, r) => .01 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.05)),
  (t, c, r) => .01 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.05)),
  (t, c, r) => .02 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.3)),
  (t, c, r) => .02 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.3)),
  (t, c, r) => .02 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.3)),
  (t, c, r) => .01 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.3)),
  (t, c, r) => .01 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - (t * 0.3)),
  (t, c, r) => ((c + (r + t * 10) ^ c - (r + t * 10)) % 11 & 1) - .1,
  (t, c, r) => ((c + (r + t * 10) ^ c - (r + t * 10)) % 11 & 1) - .1,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 17 & 1) - .1,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 17 & 1) - .1,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 13 & 1) - .15,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 15 & 1) - .125,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 9 & 1) - .2,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 13 & 1) - .15,
  (t, c, r) => Math.cos(2 * r / c ^ 2 + (t)),
  (t, c, r) => Math.cos(2 * r / c ^ 2 + (t)),
  (t, c, r) => (Math.tan(Math.sin(r / 2 - t * 0.2) * 0.2) + Math.cos(c / 2 - t * 1)) * 0.1,
  (t, c, r) => (Math.tan(Math.sin(r / 2 - t * 0.2) * 0.2) + Math.cos(c / 2 - t * 1)) * 0.1,
  (t, c, r) => (Math.tan(Math.sin(c / 2 - t * 2) * 0.6) + Math.cos(c / 2 - t * 0.2)) * 0.5,
  (t, c, r) => (Math.tan(Math.sin(c / 2 - t * 2) * 0.6) + Math.cos(c / 2 - t * 0.2)) * 0.5,
  (t, c, r) => (Math.tan(Math.sin(c / 2 - t * 2) * 0.2) + Math.cos(c / 2 - t * 2)) * 0.15,
  (t, c, r) => (Math.tan(Math.sin(c / 2 - t * 2) * 0.2) + Math.cos(c / 2 - t * 2)) * 0.05,
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.2),
  (t, c, r) => Math.sin(t * r * c / ((r) + c) * 0.2),
  (t, c, r) => Math.sin((t * 4) * r * c / ((r) + c) * 0.1),
  (t, c, r) => Math.sin((t * 4) * r * c / ((r) + c) * 0.1),
]

let mode = randI(modes.length)
let count = -1

let rowsAnimated = -1
console.log('%c🍃🍃 @ramioso 2022-12-22 🍃🍃', 'color: green');

//RNBO
let device;
let context = null
let time = null
let outputNode = null
async function setup() {
  const patchExportURL = "export/patch.export.blocks.json";

  const WAContext = window.AudioContext || window.webkitAudioContext;
  context = new WAContext();

  outputNode = context.createGain();
  outputNode.gain.value = 0
  outputNode.connect(context.destination);

  let response, patcher;
  response = await fetch(patchExportURL);
  patcher = await response.json();

  if (!window.RNBO) {
    await loadRNBOScript(patcher.desc.meta.rnboversion);
  }

  device = await RNBO.createDevice({ context, patcher });
  time = new Date()
  device.node.connect(outputNode);
  // fb
  device.parameters[4].value = targetFb
  // release
  device.parameters[9].value = 100.0
  // attack
  device.parameters[6].value = 50.0
  // sustain
  device.parameters[8].value = 0.02
  // delays
  let d = (1000 / bpm) * 120
  device.parameters[3].value = d
  device.parameters[5].value = d * 0.75
  //modulate delays?
}

function loadRNBOScript(version) {
  return new Promise((resolve, reject) => {
    if (/^\d+\.\d+\.\d+-dev$/.test(version)) {
      throw new Error("Patcher exported with a Debug Version!\nPlease specify the correct RNBO version to use in the code.");
    }
    const el = document.createElement("script");
    el.src = "./rnbo.min.js";
    el.onload = resolve;
    el.onerror = function (err) {
      console.log(err);
      reject(new Error("Failed to load rnbo.js v" + version));
    };
    document.body.append(el);
  });
}

function makeSliders(device) {
  let pdiv = document.getElementById("rnbo-parameter-sliders");
  let noParamLabel = document.getElementById("no-param-label");
  if (noParamLabel && device.numParameters > 0) pdiv.removeChild(noParamLabel);

  let isDraggingSlider = false;
  let uiElements = {};

  device.parameters.forEach(param => {
    let label = document.createElement("label");
    let slider = document.createElement("input");
    let text = document.createElement("input");
    let sliderContainer = document.createElement("div");
    let sliderContainer2 = document.createElement("div");
    sliderContainer.appendChild(label);
    sliderContainer.appendChild(sliderContainer2);
    sliderContainer2.appendChild(slider);
    sliderContainer2.appendChild(text);

    label.setAttribute("name", param.name);
    label.setAttribute("for", param.name);
    label.setAttribute("class", "param-label");
    label.textContent = `${param.name}: `;

    slider.setAttribute("type", "range");
    slider.setAttribute("class", "param-slider");
    slider.setAttribute("id", param.id);
    slider.setAttribute("name", param.name);
    slider.setAttribute("min", param.min);
    slider.setAttribute("max", param.max);
    if (param.steps > 1) {
      slider.setAttribute("step", (param.max - param.min) / (param.steps - 1));
    } else {
      slider.setAttribute("step", (param.max - param.min) / 1000.0);
    }
    slider.setAttribute("value", param.value);

    text.setAttribute("value", param.value.toFixed(1));
    text.setAttribute("type", "text");

    // Make each slider control its parameter
    slider.addEventListener("pointerdown", () => {
      isDraggingSlider = true;
    });
    slider.addEventListener("pointerup", () => {
      isDraggingSlider = false;
      slider.value = param.value;
      text.value = param.value.toFixed(1);
    });
    slider.addEventListener("input", () => {
      let value = Number.parseFloat(slider.value);
      param.value = value;
    });

    text.addEventListener("keydown", (ev) => {
      if (ev.key === "Enter") {
        let newValue = Number.parseFloat(text.value);
        if (isNaN(newValue)) {
          text.value = param.value;
        } else {
          newValue = Math.min(newValue, param.max);
          newValue = Math.max(newValue, param.min);
          text.value = newValue;
          param.value = newValue;
        }
      }
    });

    uiElements[param.name] = { slider, text };

    pdiv.appendChild(sliderContainer);
  });

  device.parameterChangeEvent.subscribe(param => {
    if (!isDraggingSlider)
      uiElements[param.name].slider.value = param.value;
    uiElements[param.name].text.value = param.value.toFixed(1);
  });
}

var isPlaying = false;
var current16thNote;
var bpm = 75 + (randI(10) * 5)
var lookahead = 5.0;
var scheduleAheadTime = 0.1;
var nextNoteTime = 0.0;
var notesInQueue = [];
var timerWorker = null;

window.requestAnimFrame = window.requestAnimationFrame;

function nextNote() {
  var secondsPerBeat = 60.0 / bpm;
  nextNoteTime += 0.25 * secondsPerBeat;

  current16thNote++;
  if (current16thNote == 16) {
    current16thNote = 0;
  }
}

let beatDur = ((60 / bpm) / 8) * 1000
let automationLength = 4
let mods = [1, 1.01, 1.02, 1.03, 1.04, 1.05, 1.06]
let releases = [120, 140, 100, 160, 180, 200]
let attacks = [10, 10, 10, 5, 20, 4]
let automation = new Array(melodyLen).fill().map(() => rand(mods))
let automation3 = new Array(melodyLen).fill().map(() => rand(releases))

let randMode = randI(modes.length)
let noteModes = new Array(melodyLen).fill().map(() => randMode)

function playNote(dur, nIn) {
  count++;
  device.parameters[2].value = automation[count % melodyLen]
  device.parameters[9].value = automation3[count % melodyLen]
  // if(count%((melodyLen*loopLength)) === (melodyLen*loopLength)*0.75){
  // }
  device.parameters[1].value = 1620 - Math.cos(((count % (melodyLen * loopLength)) / (melodyLen * loopLength)) * (Math.PI * 2)) * 1500
  if (count > 5) {
    device.parameters[4].value = THREE.MathUtils.lerp(device.parameters[4].value, targetFb, isPlaying ? 0.1 : 0.3)
  }
  if (count > 4) {
    outputNode.gain.value = THREE.MathUtils.lerp(outputNode.gain.value, 1, 0.1)
  }
  device.parameters[6].value = THREE.MathUtils.lerp(device.parameters[6].value, targetAttack, 0.1)

  let note = nIn || notes[count % melodyLen]
  let noteOnMessage = [
    144, // Code for a note on: 10010000 & midi channel (0-15)
    noteToMidi(note) - 12, // MIDI Note
    100 // MIDI Velocity
  ];
  let noteOffMessage = [
    128, // Code for a note off: 10000000 & midi channel (0-15)
    noteToMidi(note) - 12, // MIDI Note
    0 // MIDI Velocity
  ];
  let noteOnEvent = new RNBO.MIDIEvent(device.context.currentTime * 1000 + off, 0, noteOnMessage);
  let noteOffEvent = new RNBO.MIDIEvent(device.context.currentTime * 1000 + dur + off, 0, noteOffMessage);
  device.scheduleEvent(noteOnEvent);
  device.scheduleEvent(noteOffEvent);
}
let count2 = 0
let loopLength = 54 - (dimension * 8)
let targetAttack = rand(attacks)
function scheduleNote(beatNumber, time) {
  notesInQueue.push({ note: beatNumber, time: time });
  if ((count % (melodyLen * loopLength * 0.5)) === 0) {
    //mod index
    count2++;
    mode = randI(modes.length)
  }
  if (device) {
    if (((count % (melodyLen * loopLength)) >= (melodyLen * (loopLength - 1)))) {
      targetAttack = rand(attacks)

      if (randI(100) > 20) {
        automation[count % melodyLen] = rand(mods)
      }
      if (randI(100) > 60) {
        automation3[count % melodyLen] = rand(releases)
      }
      if (randI(100) > 80) {
        notes[count % melodyLen] = rand(instNotes)
      }
      noteModes[randI(melodyLen)] = randI(modes.length)
    }
    playNote(beatDur)
  }
}
function scheduler() {
  while (nextNoteTime < device.context.currentTime + scheduleAheadTime) {
    scheduleNote(current16thNote, nextNoteTime);
    nextNote();
  }
}

function play() {

  isPlaying = !isPlaying;

  if (isPlaying) { // start playing
    current16thNote = 0;
    nextNoteTime = device.context.currentTime;
    timerWorker.postMessage("start");
    return "stop";
  } else {
    timerWorker.postMessage("stop");
    return "play";
  }
}


function draw() { requestAnimFrame(draw) }

function init() {
  requestAnimFrame(draw);    // start the drawing loop.
  timerWorker = new Worker("./metronomeworker.js");

  timerWorker.onmessage = function (e) {
    if (e.data == "tick") {
      scheduler();
    }
    else
      console.log("message: " + e.data);
  };
  timerWorker.postMessage({ "interval": lookahead });
}

window.addEventListener("load", init);

let allNotes = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"]
function noteToMidi(note) {
  let i = allNotes.indexOf(note[0])
  return 12 + (note[1] * 12) + i
}
window.$fxhashFeatures = {
  dimension,
  bpm
}
setup();